export function convertirAString(datos: any): string {
  let formBody: string[] = [];
  for (const property in datos) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(datos[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  return formBody.join("&");
}

export function RutaBase(Espruebas: Boolean): string {
  if (Espruebas) return "";
  else return "/CIC";
}

export function FormateeIdentificacion(Identificacion: string): string {
  if (Identificacion.includes("-")) {
    var identifiacionNueva = Identificacion.replace(/-/g, "");
    return identifiacionNueva.substring(1, identifiacionNueva.length);
  }

  return Identificacion;
}

export function __ObtengaClasePersona(tipoPersona: string) {
  let resultado = "";
  switch (parseInt(tipoPersona)) {
    case 1:
    case 3:
    case 5:
    case 12:
      resultado = "F";
      break;
    case 2:
    case 4:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
    case 14:
    case 15:
      resultado = "J";
      break;
  }
  return resultado;
}

export async function __DescargarArchivo(
  documentoBase64: string,
  NombreArchivo: string
) {
  let bytes = await ConvertirABythes(documentoBase64);
  let blob = new Blob([bytes], { type: "application/octet-stream" }); //
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = NombreArchivo;
  link.click();
}

export async function __DescargarArchivoBlob(
  data: any,
  nombreArchivo: string
) {
  const url = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function __ConvertirABase64(file: any) {
  return new Promise((resolve, reject) => {
    if (!file) return;

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

async function ConvertirABythes(base64: string) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export async function __EsPersonaJuridica(tipoPersona: any) {
  let consulta = __ObtengaClasePersona(tipoPersona);
  if (consulta !== "J") return true;
  return false;
}

export async function __EsPersonaFisica(tipoPersona: any) {
  let consulta = __ObtengaClasePersona(tipoPersona);
  if (consulta === "F") return true;
  return false;
}

export async function __MaximoCaracteresIdentificacion(valor: any) {
  let maximo = 0;
  switch (valor) {
    case "2":
      maximo = 20;
      break;
    case "3":
      maximo = 12;
      break;
    case "4":
    case "5":
    case "6":
      maximo = 20;
      break;
    case "13":
      maximo = 10;
      break;
    default:
      maximo = 9;
  }
  return maximo;
}

export function _VerificarArray(elemento: any) {
  if (elemento.constructor.name === "Array" && elemento.length > 0)
    return elemento;
  return null;
}
